const LIVE_URL = "https://api.wallet.nsplprojects.com";
const LOCAL_URL = "http://127.0.0.1:8000";
// Local CRA → deployed API: set REACT_APP_API_URL in .env.development (no proxy).
// Local Laravel instead: REACT_APP_API_URL=http://127.0.0.1:8000
export const MAIN_URL =LIVE_URL
  // (process.env.REACT_APP_API_URL || "").replace(/\/$/, "") || LIVE_URL;

export const APPLICATION_KEY = "app";

/** Socket.io realtime server (separate from Laravel API). */
export const SOCKETIO_URL =
  process.env.REACT_APP_SOCKETIO_URL || "http://127.0.0.1:4001";

/** Headers for fetch() calls (axios interceptor does not apply to fetch). */
export function getApiHeaders(extraHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (APPLICATION_KEY) {
    headers["X-Application-Key"] = APPLICATION_KEY;
  }
  return headers;
}
